import { css, cx, keyframes } from 'emotion';
import React from 'react';

const anim1 = keyframes`
  0% {
    width: 112px;
    height: 48px;
    margin-top: 64px;
    margin-left: 0px;
  }
  12.5% {
    width: 48px;
    height: 48px;
    margin-top: 64px;
    margin-left: 0px;
  }
  25% {
    width: 48px;
    height: 48px;
    margin-top: 64px;
    margin-left: 0px;
  }
  37.5% {
    width: 48px;
    height: 48px;
    margin-top: 64px;
    margin-left: 0px;
  }
  50% {
    width: 48px;
    height: 48px;
    margin-top: 64px;
    margin-left: 0px;
  }
  62.5% {
    width: 48px;
    height: 48px;
    margin-top: 64px;
    margin-left: 0px;
  }
  75% {
    width: 48px;
    height: 112px;
    margin-top: 0px;
    margin-left: 0px;
  }
  87.5% {
    width: 48px;
    height: 48px;
    margin-top: 0px;
    margin-left: 0px;
  }
  100% {
    width: 48px;
    height: 48px;
    margin-top: 0px;
    margin-left: 0px;
  }
`;

const anim2 = keyframes`
  0% {
    width: 48px;
    height: 48px;
    margin-top: 0px;
    margin-left: 0px;
  }
  12.5% {
    width: 48px;
    height: 48px;
    margin-top: 0px;
    margin-left: 0px;
  }
  25% {
    width: 48px;
    height: 48px;
    margin-top: 0px;
    margin-left: 0px;
  }
  37.5% {
    width: 48px;
    height: 48px;
    margin-top: 0px;
    margin-left: 0px;
  }
  50% {
    width: 112px;
    height: 48px;
    margin-top: 0px;
    margin-left: 0px;
  }
  62.5% {
    width: 48px;
    height: 48px;
    margin-top: 0px;
    margin-left: 64px;
  }
  75% {
    width: 48px;
    height: 48px;
    margin-top: 0px;
    margin-left: 64px;
  }
  87.5% {
    width: 48px;
    height: 48px;
    margin-top: 0px;
    margin-left: 64px;
  }
  100% {
    width: 48px;
    height: 48px;
    margin-top: 0px;
    margin-left: 64px;
  }
`;

const anim3 = keyframes`
  0% {
    width: 48px;
    height: 48px;
    margin-top: 0px;
    margin-left: 64px;
  }
  12.5% {
    width: 48px;
    height: 48px;
    margin-top: 0px;
    margin-left: 64px;
  }
  25% {
    width: 48px;
    height: 112px;
    margin-top: 0px;
    margin-left: 64px;
  }
  37.5% {
    width: 48px;
    height: 48px;
    margin-top: 64px;
    margin-left: 64px;
  }
  50% {
    width: 48px;
    height: 48px;
    margin-top: 64px;
    margin-left: 64px;
  }
  62.5% {
    width: 48px;
    height: 48px;
    margin-top: 64px;
    margin-left: 64px;
  }
  75% {
    width: 48px;
    height: 48px;
    margin-top: 64px;
    margin-left: 64px;
  }
  87.5% {
    width: 48px;
    height: 48px;
    margin-top: 64px;
    margin-left: 64px;
  }
  100% {
    width: 112px;
    height: 48px;
    margin-top: 64px;
    margin-left: 0px;
  }
`;

const containerStyle = css`
  width: 112px;
  height: 112px;
`;

const boxStyle = css`
  border: 0;
  background-color: var(--primaryBrand);
  box-sizing: border-box;
  position: absolute;
  display: block;
`;

const box1Style = css`
  width: 112px;
  height: 48px;
  margin-top: 64px;
  margin-left: 0px;
  animation: ${anim1} 4s 0s forwards ease-in-out infinite;
`;

const box2Style = css`
  width: 48px;
  height: 48px;
  margin-top: 0px;
  margin-left: 0px;
  animation: ${anim2} 4s 0s forwards ease-in-out infinite;
`;

const box3Style = css`
  width: 48px;
  height: 48px;
  margin-top: 0px;
  margin-left: 64px;
  animation: ${anim3} 4s 0s forwards ease-in-out infinite;
`;

const centerContainer = css`
  height: 100%;
  width: 100%;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const messageStyle = css`
  margin-top: 2rem;
  font-family: Lato, sans-serif;
  text-align: center;
  font-weight: bold;
  font-size: 1.25rem;
  line-height: 1.5em;
  color: var(--primaryBrand);
`;

export const Loader = props => {
  const { message } = props;
  return (
    <div className={centerContainer}>
      <div className={containerStyle}>
        <div className={cx(boxStyle, box1Style)} />
        <div className={cx(boxStyle, box2Style)} />
        <div className={cx(boxStyle, box3Style)} />
      </div>
      <p className={messageStyle}>{message}</p>
    </div>
  );
};
